import { type UseQueryResult, useQuery } from 'react-query';
import { SandboxOptionsService, SandboxService } from '../../services/wealthlane-identity-services';
import { InstanceSwitchService } from '../../services/wealthlane-identity-services/services/InstanceSwitchService';

const useGetSandboxSwitchable = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  selectedCompanyId?: string,
  enabled?: boolean,
  onSuccess?: (
    data:
      | {
          label: string;
          value: string;
        }[]
      | undefined
  ) => void
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const sandboxSwitchable = useQuery(
    ['getSandboxSwitchable', selectedCompanyId],
    async () => {
      return await handleRequest(
        InstanceSwitchService.getApiIdentityApiInstanceSwitchable(selectedCompanyId)
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
      onSuccess,
      enabled,
      refetchOnWindowFocus: 'always',
    }
  );

  return sandboxSwitchable;
};

export default useGetSandboxSwitchable;
